{
  "version": 1,
  "asset_id": "557a46d4-d423-4107-babb-614a2454574a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/557a46d4-d423-4107-babb-614a2454574a/hiatal-type-1-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/557a46d4-d423-4107-babb-614a2454574a/hiatal-type-1-v3-1200.webp",
  "original_filename": "hiatal-type-1-v3-1200.webp",
  "size": 130018,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:09:27Z"
}
